<template>
    <section class="flex md:flex-col">
        <div>
            <AdminDashboardNav/>
        </div>
        <section class="font-poppins w-screen pr-5 pl-5 md:pr-1 md:pl-1">
            <section class="mt-6">
                <div class=" flex justify-between md:flex-col-reverse">
                    <div class="md:mt-6">
                        <GetDate/>
                        <p class="text-blue-700 font-bold text-2xl md:text-lg">MANAGE CARRIERS</p>
                    </div>

                    <div class=" mr-10">
                        <Notification/>
                    </div>
                </div>
            </section>
            <div>
                <RidersList/>
            </div>
        </section>
    </section>    
</template>

<script>
// import axios from 'axios';
import RidersList from './RidersList.vue'; 
import GetDate from '../GetDate.vue';
import Notification from '../Notification.vue';
import AdminDashboardNav from '../AdminDashboardNav.vue'
export default {
    components : {
        AdminDashboardNav,
        RidersList,
        GetDate,
        Notification
    },
    data() {
        return {
            riders : []
        }
    },
 
    mounted() {
        this.networkError()
    },

    methods: {
        networkError() {
            if(!navigator.onLine) {
                this.$router.push('/network-error')
            } 
        }
    }
}
</script>